import {actionTypes as formSettingsActionTypes} from '@/store/modules/formSettings'
import {mutationTypes as formSettingsMutationTypes} from '@/store/modules/formSettings'

export default {
  data(){
    return {
      searchString: '',
    }
  },
  computed: {
    createDialogOpen: {
      get(){return this.$store.state.formSettings.createDialogOpen},
      set(val){this.$store.commit(formSettingsMutationTypes.setCreateDialogOpen, val)}
    },
    editDialogOpen: {
      get(){return this.$store.state.formSettings.editDialogOpen},
      set(val){this.$store.commit(formSettingsMutationTypes.setEditDialogOpen, val)}
    },
    editItemId: {
      get(){return this.$store.state.formSettings.editItemId},
      set(val){this.$store.commit(formSettingsMutationTypes.setEditItemId, val)}
    },
    category: {
      get(){return this.$store.state.formSettings.category},
      set(val){this.$store.commit(formSettingsMutationTypes.setCategory, val)}
    },
    list: {
      get(){return this.$store.state.formSettings.list},
      set(val){this.$store.commit(formSettingsMutationTypes.setList, val)}
    },
    filteredList(){
      if(this.searchString.length > 0)
        return this.list.filter((item) => Object.values(item).join(' ').toLowerCase().includes(this.searchString.toLowerCase()))
      return this.list
    }
  },
  methods: {
    loadList(){
      return this.$store.dispatch(formSettingsActionTypes.loadList)
    },
    resetSearchString(){
      this.searchString = ''
    },
    openCreateDialog(){
      this.createDialogOpen = true
    }
  }
}